import ApiService from '@boServices/apiService';

class ClientService extends ApiService {
    getClients({
        search = '',
        status = 'ALL',
        category = 'ALL',
        activeOnly = false,
        withPlatforms = false,
        page = 1,
        perPage = 20,
        signal,
    } = {}) {
        const params = new URLSearchParams({ page: String(page), perPage: String(perPage) });
        if (search) params.set('search', search);
        if (status) params.set('status', status);
        if (category && category !== 'ALL') params.set('category', category);
        if (activeOnly) params.set('activeOnly', '1');
        if (withPlatforms) params.set('withPlatforms', '1');
        return this.fetchWithHeaders(`/api/v2/backoffice/clients?${params.toString()}`, 'GET', { signal });
    }

    /**
     * Reads a client; on request, with its platforms and its sub-clients (each with its platforms when the
     * platforms are requested), only the active ones with `activeOnly`.
     */
    getClient(uuid, { withPlatforms = false, withSubClients = false, activeOnly = false } = {}) {
        const params = new URLSearchParams();
        if (withPlatforms) params.set('withPlatforms', '1');
        if (withSubClients) params.set('withSubClients', '1');
        if (activeOnly) params.set('activeOnly', '1');
        const query = params.toString();
        return this.fetchWithHeaders(`/api/v2/backoffice/clients/${uuid}${query ? `?${query}` : ''}`, 'GET');
    }

    createClient(payload) {
        return this.fetchWithHeaders('/api/v2/backoffice/clients', 'POST', {
            body: JSON.stringify(payload),
        });
    }

    updateClient(uuid, payload) {
        return this.fetchWithHeaders(`/api/v2/backoffice/clients/${uuid}`, 'PUT', {
            body: JSON.stringify(payload),
        });
    }

    getContext(uuid) {
        return this.fetchWithHeaders(`/api/v2/backoffice/clients/${uuid}/context`, 'GET');
    }

    updateContext(uuid, html) {
        return this.fetchWithHeaders(`/api/v2/backoffice/clients/${uuid}/context`, 'PUT', {
            body: JSON.stringify({ html }),
        });
    }
}

export default ClientService;
